import { Center, Text } from "@mantine/core";
import {
  Procedure,
  ProcedureInstructionQueryParams,
  TablesDirectionDataT,
} from "@interfaces/company/procedure";
import React, { memo, useMemo } from "react";

import { Loader } from "@ui/indicators";
import { UseSortingResult } from "@hooks/useSorting";
import { WrapperTableCategory } from "../wrapper-table-category";
import styles from "./procedure-tables-instructions.module.scss";
import { Pagination } from "@components/pagination";

type ProcedureTablesInstructionsProps = {
  withoutEmpty?: boolean;
  TYPE: "briefing" | "training";
  sorting?: UseSortingResult | undefined;
  withoutFilters?: boolean;
  ignoredKeys?: (keyof Procedure)[];
  defaultFilters?: Partial<ProcedureInstructionQueryParams>;
  tables: TablesDirectionDataT[];
  isLoading: boolean;
  offset: number;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const ProcedureTablesInstructions: React.FC<ProcedureTablesInstructionsProps> =
  memo(
    ({
      withoutEmpty,
      TYPE,
      ignoredKeys,
      sorting,
      tables,
      isLoading,
      offset,
      page,
      totalPages,
      onPageChange,
    }) => {
      const isDataInTable = useMemo(() => {
        return tables?.filter((item) =>
          withoutEmpty ? !!item.body.length : true
        ).length;
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [tables]);

      if (isLoading) {
        return (
          <Center h={950}>
            <Loader />
          </Center>
        );
      }

      if (!isDataInTable) {
        return (
          <Text mt={40} size="xl" style={{ textAlign: "center", color: "gray" }}>
            Таблицы пусты
          </Text>
        );
      }

      return (
        <>
          {tables.map((item, i) => {
            return (
              <div key={item.id}>
                <WrapperTableCategory
                  type={TYPE}
                  key={i}
                  withName={true}
                  ignoredKeys={ignoredKeys ?? []}
                  table={item}
                  sorting={sorting}
                  offset={offset}
                />
              </div>
            );
          })}
          <div className={styles.pagination}>
            <Pagination
              value={page}
              onChange={onPageChange}
              total={totalPages}
            />
          </div>
        </>
      );
    }
  );
